import {
  Directive,
  ElementRef,
  inject,
  input,
  type OnDestroy,
  type OnInit,
} from '@angular/core';

/**
 * Adds auto scrolling and focussing to the first input that has an error.
 *
 * Will be automatically implemented on all <form> elements.
 *
 * Disable this behavior by setting `[scrollToTopErrorOnSubmitEnabled]="false"` on the form element.
 */
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'form',
})
export class ScrollToTopErrorDirective implements OnInit, OnDestroy {
  public readonly scrollToTopErrorOnSubmitEnabled = input(true);

  private readonly el = inject(ElementRef);
  private readonly scrollToTopError = () => {
    const formElement = this.el.nativeElement as HTMLFormElement;

    // find all invalid inputs on this form
    const errorInputs = formElement.querySelectorAll('.ng-invalid');

    // get the first invalid input
    const topErrorEl = errorInputs[0] as HTMLInputElement;

    // if it exist, scroll towards the element smoothly
    // (default .focus() scroll is not smooth, so we prevent that and add our own smooth scrolling)
    if (topErrorEl) {
      topErrorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      topErrorEl.focus({ preventScroll: true });
    }
  };

  ngOnInit() {
    if (this.scrollToTopErrorOnSubmitEnabled()) {
      const formElement = this.el.nativeElement as HTMLFormElement;
      formElement.addEventListener('submit', this.scrollToTopError);
    }
  }

  ngOnDestroy(): void {
    if (this.scrollToTopErrorOnSubmitEnabled()) {
      const formElement = this.el.nativeElement as HTMLFormElement;
      formElement.removeEventListener('submit', this.scrollToTopError);
    }
  }
}
